import { formatNum } from '@/util/index'
window.FORMATNUM = formatNum